import { Fragment, useContext} from 'react';
import { LanguageContext } from '../../index';
import Navbar from '../../components/Navbar/Navbar';
import PageTitle from '../../components/pagetitle/PageTitle'
import ContactPageContent from '../../components/ContactPageContent'
import Scrollbar from '../../components/scrollbar/scrollbar'
import Footer from '../../components/footer/Footer';

const ContactPage =() => {
    const { language } = useContext(LanguageContext);
    const isPolish = language === 'pl';
    return(
        <Fragment>
            <Navbar hclass={'header-style-2'}/>
            <PageTitle pageTitle={isPolish ? 'Skontaktuj się z nami' : 'Contact us'} pagesub={isPolish ? 'kontakt' : 'contact'}/> 
            <ContactPageContent/>
            <Footer/>
            <Scrollbar/>
        </Fragment>
    )
};
export default ContactPage;

